import { MapedPoliciesDataType } from 'domain/shared/compliance';
import { DateField, FieldProps } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';

const LastComplianceDocumentSigningField = (props: FieldProps) => {
  const { data } = useShowContext<MapedPoliciesDataType>();
  const { consentTimestamp, policyVersion, previousVersions } = data.getData();

  const time =
    consentTimestamp ||
    (previousVersions?.length ? previousVersions.find(item => item.consentTimestamp)?.consentTimestamp : null);
  const version = consentTimestamp
    ? policyVersion
    : previousVersions?.find(item => item.consentTimestamp)?.policyVersion;

  return (
    <Box
      display="flex"
      alignItems="center"
      mb="3.5px"
      sx={{
        lineHeight: '1.5',
      }}
    >
      <Typography sx={{ mr: '8px !important' }}>v.{version || policyVersion}</Typography>

      <DateField value={time} />
    </Box>
  );
};

export default LastComplianceDocumentSigningField;
